import ContactUsAPI from '@/app/apis/main/contact-us/contact-us-api.js';

export default {
	/**
	 * @param {*} contactUsDetails
	 * @returns {Promise}
	 */
	async postContactUs(contactUsDetails) {
		return ContactUsAPI.postContactUs(contactUsDetails);
	}
}